import {filter, isNaN} from "lodash";
import {Totals} from "./models/order";
import {TicketMap} from "./reducers/config";
import {Ticket} from "./models/hotels";

export const LOCAL_DATE_FMT = "YYYY-MM-DD";

export function moneyFormat(n: number | string, sign: string = "$"): string {
    if (isNaN(n)) {
        return n + "";
    }
    const pieces = parseFloat(n as string).toFixed(2).split("");
    let ii = pieces.length - 6;
    while (ii > 0) {
        pieces.splice(ii, 0, ",");
        ii -= 3;
    }
    return sign + pieces.join("");
}

export const ZERO_TOTALS = {
    subTotal: 0.0,
    taxTotal: 0.0,
    discountTotal: 0.0,
    grandTotal: 0.0,
} as Totals;

export function ticketsForDestination(tickets: TicketMap, destination: string): Ticket[] {
    const destinationTickets: Ticket[] = filter(tickets, t => t.destination === destination);
    destinationTickets.sort((a, b) => {
        const dc = (a.days - b.days);
        if (dc === 0) {
            return a.name.localeCompare(b.name);
        }
        return dc;
    });
    return destinationTickets;
}

export class Future<T> {
    public promise: Promise<T>;
    public resolve: (v: T) => void;
    public reject: (err: Error) => void;

    constructor() {
        this.promise = new Promise<T>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}

export function parentFrameScrollToTop() {
    if (window.self === window.top || !(window as any).__ifid) {
        return;
    }
    try {
        window.top.postMessage(JSON.stringify({
            scrollToTop: true,
            id: (window as any).__ifid
        }), "*");
    } catch (err) {
        if (console) {
            console.log(err);
        }
    }
}

export function localStorageSet (key: string, value: string) {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {
        if (console) {
            console.log(e);
        }
    }
}

export function localStorageGet (key: string): string | null {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        if (console) {
            console.log(e);
        }
    }
}

export function localStorageRemove (key: string) {
    try {
        window.localStorage.removeItem(key);
    } catch (e) {
        if (console) {
            console.log(e);
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils.ts